import api from '@/api/api'
import router from '@/router/index'
import { normalize, schema } from 'normalizr'
import { modulosOrden } from '@/store/modulosOrdenes/store'
import { promocion } from '@/store/promociones/store'
import { inmueble } from '@/store/promociones/inmuebles/store'
import { tarifa } from '@/store/promociones/inmuebles/tarifas/store'
import tarifas, { tarifaReserva } from '@/store/reservas/_id/tarifas/store'
import { comprador } from '@/store/compradores/store'

export const reserva = new schema.Entity('reserva', {'modulosOrden': modulosOrden, 'compradores': [comprador], 'tarifa': tarifaReserva})

export default {
  namespaced: true,
  modules: {
    tarifas
  },
  state: {
    list: {},
    refreshDocu: false
  },
  mutations: {
    setAll (state, payload) {
      state.list = Object.assign({}, payload)
    },
    setRefresh (state, payload) {
      state.refreshDocu = payload
    }
  },
  actions: {
    load ({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        api.get('/reservas/get', {
          params: {
            jsondata: JSON.stringify({
              parametros: {
                id
              }
            })
          }
        })
          .then(response => {
            if (response.data.result.ok) {
              dispatch('cargarDatosNormalizados', response.data.result.data.data.reserva).then(() => {
                let normalizedDataPromocion = normalize(response.data.result.data.data.promocion, promocion)
                commit('promociones/setAll', normalizedDataPromocion.entities.promocion, { root: true })
                let normalizedDataInmueble = normalize(response.data.result.data.data.inmueble, inmueble)
                commit('promociones/inmuebles/setAll', normalizedDataInmueble.entities.inmueble, { root: true })
                let normalizedDataTarifa = normalize(response.data.result.data.data.tarifa, tarifa)
                commit('promociones/inmuebles/tarifas/setAll', normalizedDataTarifa.entities.tarifa, { root: true })
                commit('promociones/inmuebles/tarifas/aplazados/setAll', normalizedDataTarifa.entities.aplazado, { root: true })
                resolve()
              })
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    setRefreshDocu ({commit}, valor) {
      commit('setRefresh', valor)
    },
    cargarDatosNormalizados ({commit}, data) {
      return new Promise((resolve) => {
        let normalizedData = normalize(data, reserva)
        commit('setAll', normalizedData.entities.reserva)
        commit('modulosOrdenes/setAll', normalizedData.entities.modulosOrden, { root: true })
        commit('modulosOrdenes/modulos/setAll', normalizedData.entities.modulo, { root: true })
        commit('reservas/_id/tarifas/setAll', normalizedData.entities.tarifaReserva, { root: true })
        commit('compradores/setAll', normalizedData.entities.comprador, { root: true })
        resolve()
      })
    },
    generarContrato ({ commit, dispatch }, obj) {
      return new Promise((resolve, reject) => {
        api.post('/reservas/generar_contrato', {
          jsondata: JSON.stringify({
            parametros: obj
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              let normalizedData = normalize(response.data.result.data.data, reserva)
              commit('setAll', normalizedData.entities.reserva)
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    enviarReserva ({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        api.post('/reservas/enviar_reserva', {
          jsondata: JSON.stringify({
            parametros: {
              id
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              let normalizedData = normalize(response.data.result.data.data, reserva)
              commit('setAll', normalizedData.entities.reserva)
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    borrarContrato ({ commit, dispatch }, obj) {
      return new Promise((resolve, reject) => {
        api.post('/reservas/borrar_contrato', {
          jsondata: JSON.stringify({
            parametros: obj
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              console.log(response.data.result.data.data)
              let normalizedData = normalize(response.data.result.data.data, reserva)
              commit('setAll', normalizedData.entities.reserva)
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    guardarContrato ({ dispatch }, {id, documento, kyc}) {
      return new Promise((resolve, reject) => {
        const formData = new FormData()
        formData.set('jsondata', JSON.stringify({
          parametros: {
            id,
            kyc
          }
        }))
        if (documento) {
          if (documento.file != null) {
            formData.append('documento[file]', documento.file)
          }
          formData.set('documento[extension]', documento.extension)
          formData.set('documento[mime]', documento.mime)
          formData.set('documento[nombre]', documento.nombre)
        }
        api.post('/documentacion/guardar_contrato', formData)
          .then(response => {
            if (response.data.result.ok) {
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    crear ({ commit, dispatch }, obj) {
      return new Promise((resolve, reject) => {
        api.post('/reservas/crear', {
          jsondata: JSON.stringify({
            parametros: {
              codigoPromocion: obj.codigoPromocion,
              simplificada: obj.simplificada,
              codigoActivo: obj.codigoActivo,
              numOportunidad: obj.numOportunidad,
              alquiler: obj.alquiler,
              compradoresScoring: obj.compradoresScoring,
              compradorTitular: obj.compradorTitular,
              usuarioComercial: obj.usuarioComercial
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              let normalizedData = normalize(response.data.result.data.data, reserva)
              commit('setAll', normalizedData.entities.reserva)
              commit('modulosOrdenes/setAll', normalizedData.entities.modulosOrden, { root: true })
              commit('modulosOrdenes/modulos/setAll', normalizedData.entities.modulo, { root: true })
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    }
  },
  getters: {
    getAll (state) {
      return Object.keys(state.list).map(id => state.list[id])
    },
    getRefreshDocu (state) {
      return state.refreshDocu
    },
    getActual (state, getters) {
      return getters.getAll[0]
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/reservas/_id/store.js